<template>
  <chart-container :title="title">
    <apexchart
      type="bar"
      :height="computedOptions.height"
      :options="computedOptions"
      :series="computedSeries"
    />
  </chart-container>
</template>

<script>
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { ApexBaseChartOptions } from "@/commons/chart-commons.js";

export default {
  components: {
    ChartContainer
  },
  props: {
    title: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedOptions() {
      const localOptions = {
        height: this.height || ApexBaseChartOptions.height,
        chart: {
          stacked: true
          //stackType: '100%' // stack 100%
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        yaxis: {
          labels: {
            minWidth: 0,
            maxWidth: 160
          }
        },
        fill: {
          opacity: 1
        }
      };
      return _merge({}, ApexBaseChartOptions, localOptions, this.options.plotOptions);
    },
    computedSeries() {
      return this.options.series;
    }
  }
};
</script>